export const WILD_CARD = '*';

export const useWildCardOption = () => {
  const handleWildCardSelect = (
    selectedOptions: string[],
    value: string | string[],
    setValue: (value: string | string[]) => void,
  ) => {
    if (typeof value === 'string') {
      return;
    }

    const option = value[value.length - 1];

    if (!option) {
      setValue([]);
      return;
    }

    if (option?.includes(WILD_CARD)) {
      setValue([option]);
      return;
    }

    const filteredOptions = selectedOptions?.filter(
      (option) => !option.includes(WILD_CARD),
    );

    if (filteredOptions?.length !== selectedOptions?.length) {
      setValue([option, ...filteredOptions]);
    }
  };

  return {
    handleWildCardSelect,
  };
};
